import { render, staticRenderFns } from "./TenantsInviteModal.vue?vue&type=template&id=530a60ea&scoped=true&"
import script from "./TenantsInviteModal.vue?vue&type=script&lang=js&"
export * from "./TenantsInviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a60ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530a60ea')) {
      api.createRecord('530a60ea', component.options)
    } else {
      api.reload('530a60ea', component.options)
    }
    module.hot.accept("./TenantsInviteModal.vue?vue&type=template&id=530a60ea&scoped=true&", function () {
      api.rerender('530a60ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/TenantsInviteModal.vue"
export default component.exports